import 'semantic-ui-css/components/dropdown';
import $ from 'jquery';

$.fn.extend({
  autoComplete() {
    this.each((index, element) => {
      const $element = $(element);
      const criteriaName = $element.data('criteria-name');
      const choiceName = $element.data('choice-name');
      const choiceValue = $element.data('choice-value');
      const autocompleteValue = $element.find('input.autocomplete').val();
      const loadForEditUrl = $element.data('load-edit-url');
      const addJsonResponse = $element.data('add-json-response');
      const optionValueName = $element.find('[data-option-value]').data('option-value-name') || 'optionValue';
      const displayEnabledStatus = $element.data('display-enabled-status') || false;
      const hideSelectedOptions = $element.data('hide-selected-options') || false;
      const $hideSelectedOptionsOfGroupedInput = $($element.data('hide-selected-options-of-grouped-input'));

      $element.dropdown({
        delay: {
          search: 250,
        },
        forceSelection: false,
        apiSettings: {
          dataType: 'JSON',
          cache: false,
          beforeSend(settings) {
            /* eslint-disable-next-line no-param-reassign */
            settings.data[String(criteriaName)] = settings.urlData.query;
            return settings;
          },
          onResponse(response) {
            const hiddenOptions = $element.data('hidden-options') || false;
            const autocompleteInputValues = $element.find('input.autocomplete').val().split(',');
            const hideAdditionalValues = $hideSelectedOptionsOfGroupedInput.length
              ? $hideSelectedOptionsOfGroupedInput.val().split(',')
              : [];

            return {
              success: true,
              results: response
                .filter(item => !hideSelectedOptions || !autocompleteInputValues.includes(String(item.id)))
                .filter(
                  item => !$hideSelectedOptionsOfGroupedInput.length || !hideAdditionalValues.includes(String(item.id)),
                )
                .filter(item => !hiddenOptions || !hiddenOptions.includes(item.id))
                .map(item => {
                  let name = item[String(choiceName)];

                  if (displayEnabledStatus) {
                    const status = item.enabled ? 'enabled' : 'disabled';
                    name += ` <span class="autocomplete-status ${status}"> ${status}</span>`;
                  }

                  if (addJsonResponse) {
                    name += ` <span class="js__bundle-data" data-value="${
                      item[String(choiceValue)]
                    }" data-data='${JSON.stringify(item)}'></span>`;
                  }

                  if (item[optionValueName]) {
                    setTimeout(() => {
                      const $item = $(`[data-value="${item[String(choiceValue)]}"]`);
                      $item.data('option-value', item[optionValueName]);
                    }, 10);
                  }

                  return {
                    name,
                    value: item[String(choiceValue)],
                  };
                }),
            };
          },
        },
      });

      if (autocompleteValue.split(',').filter(String).length > 0) {
        const $menuElement = $element.find('div.menu');

        $menuElement.api({
          on: 'now',
          method: 'GET',
          url: loadForEditUrl,
          beforeSend(settings) {
            /* eslint-disable-next-line no-param-reassign */
            settings.data[String(choiceValue)] = autocompleteValue.split(',').filter(String);

            return settings;
          },
          onSuccess(response) {
            response.forEach(item => {
              const $menuItem = $(
                `<div class="item" data-value="${item[String(choiceValue)]}">${item[String(choiceName)]}</div>`,
              );

              if (displayEnabledStatus) {
                const status = item.enabled ? 'enabled' : 'disabled';

                $(`<span class="autocomplete-status ${status}"> ${status}</span>`).appendTo($menuItem);
              }

              $menuElement.append($menuItem);
            });

            $element.dropdown('refresh');
            $element.dropdown('set selected', $element.find('input.autocomplete').val().split(',').filter(String));
          },
        });
      }
    });
  },
});
